/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Quota_Exhausted_HintInputs */

const fr_calendar_quota_exhausted_hint = /** @type {(inputs: Calendar_Quota_Exhausted_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les journées déjà entamées restent ouvertes.`)
};

/**

* @param {Calendar_Quota_Exhausted_HintInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_quota_exhausted_hint = /** @type {((inputs?: Calendar_Quota_Exhausted_HintInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Quota_Exhausted_HintInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_quota_exhausted_hint(inputs)
});